/** Recently viewed products; initialize before revealing fallback artwork. */
const RECENTLY_VIEWED_KEY = 'recentlyViewed';
const RECENTLY_VIEWED_MAX_ITEMS = 10;

function getRecentlyViewedProducts() {
  try {
    const items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY));
    if (!Array.isArray(items)) return [];
    return items.filter(item => {
      if (!item || typeof item.title !== 'string' || !item.url) return false;
      try {
        const url = new URL(item.url, location.origin);
        return url.origin === location.origin && url.pathname.includes('/products/');
      } catch (_) { return false; }
    }).slice(0, RECENTLY_VIEWED_MAX_ITEMS);
  } catch (_) { return []; }
}

function recordRecentlyViewedProduct(data) {
  if (!data || typeof data.id === 'undefined') return;
  const list = getRecentlyViewedProducts().filter(item => String(item.id) !== String(data.id));
  list.unshift(data);
  try { localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list.slice(0, RECENTLY_VIEWED_MAX_ITEMS))); } catch (_) {}
}

function clearRecentlyViewedProducts() {
  try { localStorage.removeItem(RECENTLY_VIEWED_KEY); } catch (_) {}
}

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.listReady === 'true') { this.initSlider(); return; }
    const products = getRecentlyViewedProducts();
    const heading = this.parentElement?.querySelector('[data-recently-viewed-heading]');
    if (heading) heading.textContent = products.length ? heading.dataset.historyTitle : heading.dataset.fallbackTitle;
    const fallback = this.querySelector('template')?.content.cloneNode(true);
    if (products.length) {
      const swiper = document.createElement('div');
      swiper.className = 'swiper';
      swiper.innerHTML = '<div class="swiper-pagination"></div><div class="swiper-wrapper"></div><div class="swiper-scrollbar"></div>';
      const wrapper = swiper.querySelector('.swiper-wrapper');
      for (const product of products) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = '<div class="recently-product-item"><a><div class="image__wrapper"></div><div class="card-information"><span class="recently-product-title h3"></span><div class="price"></div></div></a></div>';
        slide.querySelector('a').href = product.url;
        const image = document.createElement('img');
        try {
          const imageURL = new URL(product.image, location.origin);
          if (['https:', 'http:'].includes(imageURL.protocol)) image.src = imageURL.href;
        } catch (_) {}
        image.alt = product.title;
        image.width = 800;
        image.height = 800;
        image.loading = 'lazy';
        slide.querySelector('.image__wrapper').append(image);
        slide.querySelector('.recently-product-title').textContent = product.title;
        slide.querySelector('.price').textContent = product.price || '';
        wrapper.append(slide);
      }
      this.replaceChildren(swiper);
    } else if (fallback) {
      this.replaceChildren(fallback);
    } else {
      this.replaceChildren();
    }
    this.initSlider();
    this.dataset.listReady = 'true';
    this.removeAttribute('aria-busy');
    document.dispatchEvent(new CustomEvent('njt:list-ready'));
  }
  initSlider() {
    if (this.slider && !this.slider.destroyed) return;
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;
    if (typeof Swiper === 'undefined') {
      clearTimeout(this.initTimer);
      this.initTimer = setTimeout(() => { if (this.isConnected) this.initSlider(); }, 250);
      return;
    }
    const count = swiperEl.querySelectorAll('.swiper-slide').length;
    const perView = maximum => count > 1 ? Math.min(maximum, count - 0.2) : 1;
    this.slider = new Swiper(swiperEl, {
      slidesPerView: perView(2), spaceBetween: 20, freeMode: false,
      speed: 250, rewind: true, loop: false,
      observer: true, observeParents: true,
      scrollbar: {el: swiperEl.querySelector('.swiper-scrollbar'), draggable: true},
      pagination: {el: swiperEl.querySelector('.swiper-pagination'), clickable: true},
      breakpoints: {768: {slidesPerView: perView(4.2), spaceBetween: 20}}
    });
    this.rotateTimer = setInterval(() => {
      if (!this.isConnected || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!this.slider || this.slider.destroyed || count < 2) return;
      const bounds = this.getBoundingClientRect();
      if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
      this.slider.update();
      if (this.slider.isEnd) this.slider.slideTo(0);
      else this.slider.slideNext();
    }, 3500);
  }
  disconnectedCallback() {
    clearTimeout(this.initTimer);
    clearInterval(this.rotateTimer);
    this.slider?.destroy(true, true);
    this.slider = null;
  }

}
customElements.define('recently-viewed-products', RecentlyViewedProducts);
